// Third-party Library
import { useState, useRef } from "react"
import { Modal, Tooltip, message } from "antd";
import { MicNoneOutlined, MicOffOutlined } from '@mui/icons-material';
import PCMPlayer from 'pcm-player';

// Components
import { PrimaryButton } from "../../../Decoration/Button";

// Children Component (the Content)
const ModalContent = ({
    open,
    onCancelHDLR,
    intercom,
    intercomPlayHDLR,
    intercomStopHDLR
}) => {

    return (
        <Modal
            open={open}
            onCancel={onCancelHDLR}
            closable={false}
            footer={false}
            width={350}
        >
            <div style={{ textAlign: 'center', display: 'block' }}>
                <h2>Intercom is {intercom ? 'disabled' : 'enabled'}</h2>
                <p>Press button to start and press again to stop</p>
                <div style={{ backgroundColor: 'orange', borderRadius: '50%', height: '5em', width: '5em', margin: '2em auto', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                    {
                        intercom ? 
                            <MicNoneOutlined style={{ color: '#fff', fontSize: '3em' }} onClick={intercomPlayHDLR}/>
                            :
                            <MicOffOutlined style={{ color: '#fff', fontSize: '3em' }} onClick={intercomStopHDLR}/>
                    }
                </div>
                <PrimaryButton onClick={onCancelHDLR}>Close</PrimaryButton>
            </div>
        </Modal>
    )
}

// Main Component
const ModalIntercom = ({
    mdvrid,
    deviceMDVR
}) => {

    /**
     * Main functions (Modal purpose)
     */
    const [ open, setOpen ] = useState(false)

    const onCancelHDLR = () => {
        setOpen(false)
        intercomStopHDLR()
    }

    const onClickHDLR = () => {
        
        if(!deviceMDVR) {
            message.error('Vehicle is not assigned with MDVR')
        }
        else if(!deviceMDVR?.IsOnline) {
            message.warning('MDVR is currently offline.')
        }
        else if(deviceMDVR?.IsOnline) {
            setOpen(true)
        }
    }

    /**
     * Intercom functions
     */

    const playerRef = useRef(null)
    const wsRef = useRef(null)

    const [ intercom, setIntercom ] = useState(true)

    const intercomPlayHDLR = () => {
        const sampleRate = 8000;

        // 1) Player
        playerRef.current = new PCMPlayer({
            encoding: '16bitInt',
            channels: 1,
            sampleRate,
            flushingTime: 2000,
        });

        // 2) WS
        const url = `wss://202.126.209.190:8084/VoiceIntercom/100?DeviceId=${mdvrid}&AudioType=0&SampleRate=${sampleRate}`;
        wsRef.current = new WebSocket(url);
        wsRef.current.binaryType = 'arraybuffer';

        wsRef.current.onopen = () => {
            wsRef.current.send(JSON.stringify({ 
                Type: 'VoiceIntercom', 
                DeviceId: mdvrid 
            }));
        };

        wsRef.current.onmessage = (e) => {
            if (e.data instanceof ArrayBuffer) {
                var AudioData = event.data.slice(9)
                var data = new Uint8Array(AudioData);
                wsRef.current.feed(data);
            }
            return
        };

        // 3) Mic → resample 48k→16k → send s16le mono
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                const AudioCtx = window.AudioContext || window.webkitAudioContext;
                const audioCtx = new AudioCtx();
                const source = audioCtx.createMediaStreamSource(stream);
                const processor = audioCtx.createScriptProcessor(1024, 1, 1);

                source.connect(processor);

                const silent = audioCtx.createGain();
                silent.gain.value = 0;
                processor.connect(silent);
                silent.connect(audioCtx.destination);

                const ratio = audioCtx.sampleRate / sampleRate;

                processor.onaudioprocess = (e) => {
                    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return;

                    const input = e.inputBuffer.getChannelData(0);

                    // light LPF
                    const win = 6, filtered = new Float32Array(input.length);
                    let acc = 0;
                    for (let i = 0; i < input.length; i++) {
                        acc += input[i]; if (i >= win) acc -= input[i - win];
                        filtered[i] = acc / Math.min(i + 1, win);
                    }

                    // resample + quantize to s16le
                    const outLen = Math.floor(filtered.length / ratio);
                    const out = new Int16Array(outLen);
                    let pos = 0;
                    for (let i = 0; i < outLen; i++) {
                        const i0 = Math.floor(pos), frac = pos - i0;
                        const s0 = filtered[i0] || 0, s1 = filtered[i0 + 1] || s0;
                        const s = s0 + (s1 - s0) * frac;
                        out[i] = (Math.max(-1, Math.min(1, s)) * 0x7fff) | 0;
                        pos += ratio;
                    }
                    wsRef.current.send(out.buffer);
                };

                wsRef.current.onclose = () => {
                    if (wsRef.current) wsRef.current.close()
                }

                setIntercom(false);
            })
            .catch((err) => {
                console.error('Mic error:', err);
                message.error('Failed in connecting intercom.');
                intercomStopHDLR();
            });
    };

    const intercomStopHDLR = () => {
        if (wsRef.current) wsRef.current.close(1000, "stop voicetalk");
        if (playerRef.current) playerRef.current.destroy();
        wsRef.current = null;
        playerRef.current = null;

        setTimeout(() => setIntercom(true), 1000)
    };

    // Intercom icon
    return (
        <>
            <ModalContent 
                open={open}
                intercom={intercom} 
                onCancelHDLR={onCancelHDLR} 
                intercomPlayHDLR={intercomPlayHDLR} 
                intercomStopHDLR={intercomStopHDLR} 
            />
            <Tooltip placement="right" title={deviceMDVR?.IsOnline && 'Intercom is available. Click to turned it on.'}>
                <div style={{ backgroundColor: '#acacac', height: '20px', display: 'inline-block', marginTop: '10px', borderRadius: '2px', cursor: 'pointer' }}>
                    <MicNoneOutlined style={{ color: '#fff', fontSize: '20px' }} onClick={onClickHDLR}/>
                </div>
            </Tooltip>
        </>
    )
}

export default ModalIntercom